import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";
import ConversationEffect from "src/Animations/ConversationEffect";

export const DATA_DS_DEMO_DNA2_6 = {
  title: `After implementing all the business \nrules, Vignesh can schedule the pipeline. \nThis enables him to make future <span style="color: #92D1FF;">edits to \nthe batch pipeline effortlessly, using a \n low-code, no-code interface.</span>`,
  subtitle: "Data STREAMS demo",
  next: {
    label: "CONTINUE",
    onClick: () => {
      setPreviousPage(210);
      setCurrentPage(211);
    },
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(209),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA2/DNA2_DS_DEMO_06_computer.png",
          imageStyle: {
            position: "absolute",
            right: "179.38px",
            bottom: "186.63px",
            zIndex: 1,
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_06_bubble_2.png",
          imageStyle: {
            position: "absolute",
            right: "112px",
            bottom: "586px",
            zIndex: 0,
          },
        },
        {
          image: "DNA2/DNA2_DS_DEMO_06_bubble_1.png",
          imageStyle: {
            position: "absolute",
            right: "279px",
            bottom: "248px",
            zIndex: 1,
          },
        },
      ]}
      pageNumber={210}
    />
  ),
};
